<!--加载动画-->
<template>
    <div ref="scroll" id="scroll-page" style="overflow: hidden">
        <!--插槽相当于
        <article-item v-for="article in articles"
                      :key="article.id"
                      v-bind="article">
        </article-item>-->
        <slot></slot>
        <!--loading动画，加载的数据的过程中显示 elementUI load-->
        <div
                style="height: 40px;margin-top: 10px;z-index: 1"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(245,245,245)">
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            loading: Boolean,
            noData: Boolean,
            offset: Number
        },
        mounted() {
            //绑定事件监听,滚动的时候触发
            window.addEventListener('scroll', this.handleScroll, false);
        },
        beforeDestroy() {
            //移出事件监听
            window.removeEventListener('scroll', this.handleScroll);
        },
        data() {
            return {
                scrollAction: {
                    x: 'undefined',
                    y: 'undefined'
                }
            }
        },
        methods: {
            handleScroll(e) {
                let that = this;
                if (!that.noData) {
                    //如果有数据，触发
                    let curHeight = document.documentElement.scrollTop || document.body.scrollTop;
                    //获取div区域
                    let scrollPage = document.getElementById('scroll-page');

                    if ((curHeight + window.innerHeight >= that.$refs.scroll.offsetHeight + that.offset) && that.isDownDirection()) {
                        //判断是否到达底部
                        if (!that.loading) {
                            //调用load加载数据
                            that.$emit('load')
                        }
                    }
                }
            },
            isDownDirection() {
                if (typeof this.scrollAction.x == 'undefined') {
                    this.scrollAction.x = window.pageXOffset;
                    this.scrollAction.y = window.pageYOffset;
                }
                let diffX = this.scrollAction.x - window.pageXOffset;
                let diffY = this.scrollAction.y - window.pageYOffset;

                this.scrollAction.x = window.pageXOffset;
                this.scrollAction.y = window.pageYOffset;

                if (diffX < 0) {
                    // Scroll right
                } else if (diffX > 0) {
                    // Scroll left
                } else if (diffY < 0) {
                    // Scroll down
                    return true
                } else if (diffY > 0) {
                    // Scroll up
                } else {
                    // First scroll event
                }
                return false
            }

        }
    }
</script>

<style scoped>

</style>
